import React, {useState,useContext,useEffect} from "react";
import userContext from "../../../../context/users/UserContext";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import studyviewerContext from "../../../../context/studyviewer/StudyviewerContext";
import { REPORTDONESTATUS, USERTYPES } from "../../../../constants/Constants";
import LockStudyTopBarIcon from "../../../../components/SVGComponents/LockStudyTopBarIcon";
import CustomToolTipHost from "../../../../components/CustomToolTipHost/CustomToolTipHost";
import { t } from "i18next";
import { getEnv } from '../../../../helpers/EnvHelper';
import { isMobile } from "react-device-detect";
import ToolbarMoreMenuRow from "../Toolbar/ToolbarMoreMenuRow";

const LockStudy = (props) => {

    const {
        assignmentData,
        studyParentAssignmentData,
        studyParentId,
        reportMenu,
      } = useContext(studyviewerContext);

    
      const {
        showLockWarning,
        lockStudy,
        lockStudySupervisor,
        showLockButton,
        alreadyLocked,
        setShowReturnStudyModal,
        reportDoneStatusState,
        reportingDoctorName,
        showCommunicationModal,
        setShowCommunicationModal,
        releaseStudy
      } = useContext(studyReportContext);

  const { roles, userId, authenticated, loadByUsername, username, contextSwitchUser, isActiveData, qcReviewer, qcSelfLockDisabled} =
    useContext(userContext);

  let isBvpPlatform = (getEnv("REACT_APP_BVP_PLATFORM") == "true" || getEnv("REACT_APP_BVP_PLATFORM") == true) ? true : false;


    const checkForTopBarLockIcon = () => {
      if(contextSwitchUser || !isActiveData)
        return false;
      
        switch (true) {
          case roles[0] === USERTYPES.RADIOLOGIST:
            if (
              (alreadyLocked || showLockWarning) &&
              !(
                assignmentData != undefined &&
                assignmentData?.assignedRadiologist != null &&
                assignmentData?.assignedRadiologist != undefined &&
                assignmentData?.assignedRadiologist != username              
              ) &&
              !(
                reportingDoctorName != null &&
                reportingDoctorName != undefined &&
                reportingDoctorName != username
              ) &&
              reportDoneStatusState != REPORTDONESTATUS.REPORTED &&
              reportDoneStatusState != REPORTDONESTATUS.QC_FIX &&
              reportDoneStatusState != REPORTDONESTATUS.PRELIMINARY_QC_FIX &&
              reportDoneStatusState != REPORTDONESTATUS.QC_REVIEW &&
              reportDoneStatusState != REPORTDONESTATUS.PRELIMINARY_QC_REVIEW &&
              reportDoneStatusState != REPORTDONESTATUS.QC_VERIFY &&
              reportDoneStatusState != REPORTDONESTATUS.PRELIMINARY_QC_VERIFY
            ) {
              return true;
            }
            return false;
          case roles[0] === USERTYPES.SUPERVISOR:
            if(qcReviewer && (((reportDoneStatusState == REPORTDONESTATUS.QC_REVIEW ||
              reportDoneStatusState == REPORTDONESTATUS.PRELIMINARY_QC_REVIEW) && !qcSelfLockDisabled) ||
              reportDoneStatusState == REPORTDONESTATUS.QC_VERIFY ||
              reportDoneStatusState == REPORTDONESTATUS.PRELIMINARY_QC_VERIFY)){
                return true;
              }
            return false;
          default:
            return false;
        }
      };

    const checkForAlreadyLockedOrNot = () => {
        switch (true) {
          case roles[0] === USERTYPES.RADIOLOGIST:
            return !alreadyLocked;
    
          case roles[0] === USERTYPES.SUPERVISOR:
            if (!props.changeLockIcon) {
              if (
                studyParentAssignmentData?.qcreviewerId == null &&
                studyParentAssignmentData?.qcverifierId == null
              ) {
                return true;
              } else {
                return checkIfUserAlreadyLocked();
              }
            } else {
              return false;
            }
          default:
            return false;
        }
      };
    
      const checkIfUserAlreadyLocked = () => {
        
        if (
          studyParentAssignmentData?.qcreviewerId != null &&
          (reportDoneStatusState == REPORTDONESTATUS.QC_REVIEW ||
            reportDoneStatusState == REPORTDONESTATUS.PRELIMINARY_QC_REVIEW)
        ) {
          return false;
        } else if (
          studyParentAssignmentData?.qcverifierId != null &&
          (reportDoneStatusState == REPORTDONESTATUS.QC_VERIFY ||
            reportDoneStatusState == REPORTDONESTATUS.PRELIMINARY_QC_VERIFY)
        ) {
          return false;
        }
        return true;
      };
    
      const checkForSelfLock = () => {
        if (
          studyParentAssignmentData?.qcreviewerId != null &&
          (reportDoneStatusState == REPORTDONESTATUS.QC_REVIEW ||
            reportDoneStatusState == REPORTDONESTATUS.PRELIMINARY_QC_REVIEW)
          && studyParentAssignmentData?.qcreviewerId === userId
        ) {
          return false;
        } else if (
          studyParentAssignmentData?.qcverifierId != null &&
          (reportDoneStatusState == REPORTDONESTATUS.QC_VERIFY ||
            reportDoneStatusState == REPORTDONESTATUS.PRELIMINARY_QC_VERIFY)
          && studyParentAssignmentData?.qcverifierId === userId
        ) {
          return false;
        }
        return true;
      }

    // const showOnMobile = isMobile &&
    //   roles.length > 0 &&
    //   (roles[0] === USERTYPES.RADIOLOGIST || roles[0] === USERTYPES.SUPERVISOR);

    const handleLockClick = () => {
      if (checkForAlreadyLockedOrNot()) {
        if (roles[0] === USERTYPES.RADIOLOGIST) {
          lockStudy(false, assignmentData);
        } else {
          lockStudySupervisor(
            false,
            studyParentAssignmentData,
            props.setChangeLockIcon
          );
        }
      } else {
        if (roles[0] === USERTYPES.RADIOLOGIST && !isBvpPlatform) {
          setShowReturnStudyModal(true);
        } else if (roles[0] === USERTYPES.RADIOLOGIST && isBvpPlatform){
          releaseStudy(studyParentId);
        }
      }
      props.onSelect?.();
    };

    const isMenuVariant = props.variant === "menu";

    return (
         checkForTopBarLockIcon() && (
            <CustomToolTipHost
              content={
                checkForAlreadyLockedOrNot() ? (
                  <span>
                    {t("string-literals.not-locked-by-you")}{" "}
                    <span
                      onClick={() => {
                        if (roles[0] === USERTYPES.RADIOLOGIST) {
                          lockStudy(false, assignmentData);
                        } else {
                          lockStudySupervisor(
                            false,
                            studyParentAssignmentData,
                            props.setChangeLockIcon
                          );
                        }
                      }}
                      style={{
                        textDecoration: "underline",
                        cursor: "pointer",
                      }}
                    >
                      {t("string-literals.lock-study")}
                    </span>
                  </span>
                ) : (
                  <span>
                     {roles[0] === USERTYPES.RADIOLOGIST && <span>{t("string-literals.locked-by-you")}{" "}</span>}
                    {roles[0] === USERTYPES.SUPERVISOR && checkForSelfLock() ? t("string-literals.not-locked-by-you")
                    :roles[0] !== USERTYPES.RADIOLOGIST?t("string-literals.locked-by-you"):<></>}

                    {roles[0] === USERTYPES.RADIOLOGIST && !isBvpPlatform && (
                      <span
                        onClick={() => setShowReturnStudyModal(true)}
                        style={{
                          textDecoration: "underline",
                          cursor: "pointer",
                        }}
                      >
                        {t("return-study.studyviewer.title")}
                      </span>
                    )}

                    {roles[0] === USERTYPES.RADIOLOGIST && isBvpPlatform && (
                      <span
                        onClick={() => releaseStudy(studyParentId)}
                        style={{
                          textDecoration: "underline",
                          cursor: "pointer",
                        }}
                      >
                        Release
                      </span>
                    )}
                  </span>
                )
              }
              id="Lock Study"
              tooltipProps={{
                calloutProps: {
                  styles: {
                    beak: { background: "#252525;" },
                    beakCurtain: { background: "#252525;" },
                    calloutMain: { background: "#252525;" },
                    borderRadius: "20%",
                  },
                },
              }}
            >
              {isMenuVariant ? (
                <ToolbarMoreMenuRow label={t("heading.lock")} onClick={handleLockClick}>
                  <div className="highlight-tool">
                    <LockStudyTopBarIcon active={checkForAlreadyLockedOrNot()} />
                  </div>
                </ToolbarMoreMenuRow>
              ) : (
              <span
                className="topbar-toolbar-lock-warning"
                onClick={handleLockClick}
                style={{
                  display: "flex",
                  flexDirection: isMobile ? "column" : "row",
                  alignItems: "center",
                  justifyContent: "center",
                  paddingRight: isMobile ? "0px" : undefined,
                  marginRight: isMobile ? undefined : 0,
                }}
              >
                {isMobile ? (
                  <LockStudyTopBarIcon active={checkForAlreadyLockedOrNot()} />
                ) : (
                  <div className="highlight-tool">
                    <LockStudyTopBarIcon active={checkForAlreadyLockedOrNot()} />
                  </div>
                )}
                {isMobile && (
                  <span
                    style={{
                      fontSize: "9px",
                      lineHeight: "100%",
                      fontWeight: "400",
                      color: "var(--mobile-color-txt)",
                      marginTop: "5px",
                    }}
                  >
                    {checkForAlreadyLockedOrNot() ? "Lock" : "Return"}
                  </span>
                )}
              </span>
              )}
            </CustomToolTipHost>
          )
    )
}

export default LockStudy;